export default function NegotiationTypes() {
  const types = [
    { icon: 'ri-building-2-line', title: 'B2B переговоры', desc: 'Многоуровневые сделки с длинным циклом, множеством лиц, принимающих решения, и высокими ставками.' },
    { icon: 'ri-user-line', title: 'B2C переговоры', desc: 'Работа с конечным потребителем: эмоциональные решения, работа с возражениями по цене, быстрое закрытие.' },
    { icon: 'ri-store-line', title: 'Переговоры с закупщиками', desc: 'Профессиональные закупщики со своими KPI, тендерные процедуры, агрессивные тактики снижения цены.' },
    { icon: 'ri-file-list-3-line', title: 'Тендерные переговоры', desc: 'Подготовка к тендерам, работа с конкурентными преимуществами, защита маржинальности.' },
    { icon: 'ri-arrow-up-circle-line', title: 'Повышение цены', desc: 'Как обосновать повышение цены текущим клиентам. Аргументация, тайминг, управление реакцией.' },
    { icon: 'ri-refresh-line', title: 'Продление договора', desc: 'Переговоры о продлении на улучшенных условиях. Увеличение среднего чека при продлении.' },
    { icon: 'ri-user-star-line', title: 'Переговоры руководителей', desc: 'Стратегические переговоры между первыми лицами, партнёрские соглашения, M&A коммуникации.' },
    { icon: 'ri-error-warning-line', title: 'Конфликтные переговоры', desc: 'Работа с конфликтами: возврат к конструктивному диалогу, медиативные техники, выход из тупика.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Какие <strong>переговоры</strong> чаще всего разбираем
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            В зависимости от специфики бизнеса мы адаптируем программу под конкретные типы <strong>деловых переговоров</strong>, с которыми ваша команда сталкивается ежедневно.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {types.map((item, i) => (
            <div key={i} className="bg-white rounded-xl p-6 hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 group cursor-default">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-600 transition-colors duration-300 flex-shrink-0">
                <i className={`${item.icon} text-xl text-teal-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}